/**
 * Format delay into a day string
 *
 * @export
 * @param {Number} delay in milliseconds
 * @returns
 */
export default function formatDelay(delay) {
	let delayDay = Math.floor(delay / 86400000)
	if(delayDay === 0) return 'T=0'
	else if(delayDay > 0) return 'T+' + delayDay
	else return 'T' + delayDay
}